import dateBaseValidator from './date';

export default dateBaseValidator;
